<app-ui-dialog-shell title="Archive budget">
  <div class="space-y-6">
    <p class="m-0 text-sm text-text-muted">
      Archive <strong class="text-text-title">{{ data.bucket.name }}</strong
      > after saving this edit session.
    </p>

    @if (needsTransferTarget) {
      <div class="rounded-md border border-border-muted bg-surface-subtle p-4">
        <div class="text-[11px] font-semibold uppercase text-text-muted">{{ transferLabel }}</div>
        <div class="mt-1 text-lg font-bold tabular-nums text-text-title">
          {{ balance | currency: 'USD' : 'symbol' : '1.2-2' }}
        </div>
      </div>

      @if (data.candidates.length) {
        <label class="app-ui-label block" for="archive-budget-transfer-target">
          Transfer budget
        </label>
        <select
          id="archive-budget-transfer-target"
          appUiInput
          class="w-full"
          [(ngModel)]="transferBalanceBucketId"
        >
          @for (candidate of data.candidates; track candidate.id) {
            <option [value]="candidate.id">{{ candidate.name }}</option>
          }
        </select>
      } @else {
        <p class="m-0 rounded-md border border-status-danger/30 bg-status-danger/10 p-4 text-sm text-status-danger">
          Add or keep another active budget before archiving this budget with a remaining balance.
        </p>
      }
    } @else {
      <p class="m-0 rounded-md border border-border-muted bg-surface-subtle p-4 text-sm text-text-muted">
        This budget has no remaining balance to transfer.
      </p>
    }

    <div class="flex justify-end gap-2">
      <button appUiButton appearance="outline" tone="neutral" type="button" (click)="cancel()">Cancel</button>
      <button
        appUiButton
        tone="danger"
        type="button"
        [disabled]="needsTransferTarget && !transferBalanceBucketId"
        (click)="confirm()"
      >
        Mark archived
      </button>
    </div>
  </div>
</app-ui-dialog-shell>
